(function () {
  // Pressure washer hero extras on top of product-page.js: the "washer only / washer + kit" upsell
  // and the cleaning kit tabs/slider.
  if (window.pwProductReady) return;
  window.pwProductReady = true;

  function initUpsell(root) {
    if (root.dataset.pwReady === "true") return;
    root.dataset.pwReady = "true";

    // The options are links: washer only, or a kit's bundle.
    root.addEventListener("change", function (event) {
      var href = event.target.getAttribute("data-href");
      if (!href) return;
      var url = new URL(withPageParams(href), window.location.href);
      // A ?view= preview keeps its template family: the washer opens in the single template,
      // a kit in the bundle template.
      var view = url.searchParams.get("view");
      if (view) {
        url.searchParams.set(
          "view",
          event.target.value === "washer" ? view.replace("washer-bundle", "washer-single") : view.replace("washer-single", "washer-bundle")
        );
      }
      window.location.href = url.pathname + url.search + url.hash;
    });
  }

  // Keep the sticky gallery just below the sticky header, whatever its height (announcement bar, breakpoint).
  function trackHeaderHeight() {
    var header = document.querySelector(".wrapper > .header") || document.querySelector("[data-header]");
    if (!header) return;
    var setHeight = function () {
      document.documentElement.style.setProperty("--pw-header-height", Math.round(header.getBoundingClientRect().height) + "px");
    };
    setHeight();
    if ("ResizeObserver" in window) new ResizeObserver(setHeight).observe(header);
    else window.addEventListener("resize", setHeight);
  }

  // Kit bundle links keep the page's query parameters (?view= preview templates, UTMs, discount codes, …).
  // "variant" is dropped because variant ids belong to the current product. The hrefs are written on load,
  // so new-tab / middle-click / copied links carry them too, and again on click in case the URL changed.
  function withPageParams(href) {
    var target = new URL(href, window.location.href);
    var current = new URLSearchParams(window.location.search);
    current.delete("variant");
    current.forEach(function (value, key) {
      target.searchParams.set(key, value);
    });
    return target.pathname + target.search + target.hash;
  }

  function carryParams(link) {
    if (link.getAttribute("aria-current") === "page") return;
    if (!link.dataset.pwBaseHref) link.dataset.pwBaseHref = link.getAttribute("href") || "";
    link.setAttribute("href", withPageParams(link.dataset.pwBaseHref));
  }

  function syncKitLinks(scope) {
    scope.querySelectorAll("a.pw-kits__cta").forEach(carryParams);
  }

  ["click", "auxclick", "contextmenu", "focusin"].forEach(function (type) {
    document.addEventListener(type, function (event) {
      var link = event.target.closest ? event.target.closest("a.pw-kits__cta") : null;
      if (link) carryParams(link);
    });
  });

  // Car / 4WD / Marine tabs and the kit cards move together: a tab slides to its card,
  // swiping (mobile) lights up the matching tab. Starts on the current product's card.
  function initKits(root) {
    if (root.dataset.pwReady === "true" || typeof window.Swiper !== "function") return;
    var el = root.querySelector("[data-pw-kits-swiper]");
    if (!el) return;
    root.dataset.pwReady = "true";

    var tabs = root.querySelectorAll("[data-pw-kits-tab]");
    var setTab = function (index) {
      tabs.forEach(function (tab, i) {
        tab.classList.toggle("is-active", i === index);
        tab.setAttribute("aria-selected", i === index ? "true" : "false");
      });
    };

    // On wider phones the track runs out before the last card reaches the active position, so
    // Swiper never makes it active: once scrolled to the end, the last card counts as active.
    // A tapped tab wins until the next swipe (on those phones the middle card can also sit at the end).
    var picked = null;
    var sync = function (sw) {
      var last = sw.slides.length - 1;
      var index = picked !== null ? picked : sw.isEnd && !sw.isBeginning ? last : sw.activeIndex;
      setTab(index);
      if (sw.pagination && sw.pagination.bullets) {
        sw.pagination.bullets.forEach(function (bullet, i) {
          bullet.classList.toggle("swiper-pagination-bullet-active", i === index);
        });
      }
    };

    var swiper = new window.Swiper(el, {
      slidesPerView: "auto",
      spaceBetween: 10,
      initialSlide: Number(el.dataset.initial) || 0,
      pagination: { el: root.querySelector("[data-pw-kits-pagination]"), clickable: true },
      breakpoints: { 769: { slidesPerView: 1, spaceBetween: 16 } },
      on: {
        init: sync,
        slideChange: sync,
        reachEnd: sync,
        fromEdge: sync,
        paginationUpdate: sync,
        touchStart: function () {
          picked = null;
        }
      }
    });

    var dots = root.querySelector("[data-pw-kits-pagination]");
    if (dots) {
      dots.addEventListener("click", function (event) {
        var bullet = event.target.closest(".swiper-pagination-bullet");
        if (!bullet) return;
        picked = Array.prototype.indexOf.call(dots.children, bullet);
        sync(swiper);
      });
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener("click", function () {
        picked = i;
        swiper.slideTo(i);
        sync(swiper);
      });
    });
  }

  // Foam system cards: product-page.js switches the variant and the is-active class; keep aria-checked in step.
  document.addEventListener("click", function (event) {
    var option = event.target.closest(".pw-foam__option");
    if (!option) return;
    option.parentElement.querySelectorAll(".pw-foam__option").forEach(function (item) {
      item.setAttribute("aria-checked", item === option ? "true" : "false");
    });
  });

  function initAll(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    context.querySelectorAll("[data-pw-upsell]").forEach(initUpsell);
    context.querySelectorAll("[data-pw-kits]").forEach(initKits);
    syncKitLinks(context);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
      trackHeaderHeight();
    });
  } else {
    initAll(document);
    trackHeaderHeight();
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
